import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import _, { set } from 'lodash'
import { integrationKeyMatches } from './integrationKeyMatching'
import ShopifyLogo from '../../assets/images/logos/shopify.svg'
import WoocommerceLogo from '../../assets/images/logos/woocommerce.svg'
import WordpressLogo from '../../assets/images/logos/wordpress.svg'
import { isStoreLessAccount, isWooCommerceChannel } from '../../modules/storeTools'
import AmazonLogo from '../../assets/images/logos/amazon.svg'
import BigcommerceLogo from '../../assets/images/logos/bigcommerce.svg'
import GoogleAnalyticsLogo from '../../assets/images/logos/google_analytics.svg'
import GoogleTagManagerLogo from '../../assets/images/logos/google_tag_manager.svg'
import MagentoLogo from '../../assets/images/logos/magento.svg'
import StripeLogo from '../../assets/images/logos/stripe.svg'
import MailchimpLogo from '../../assets/images/logos/mailchimp.svg'
import SalesforceLogo from '../../assets/images/logos/salesforce.svg'
import ShipsuranceLogo from '../../assets/images/logos/shipsurance.svg'
import FedExLogo from '../../assets/images/logos/fedEx.svg'
import UspsLogo from '../../assets/images/logos/usps.svg'
import UpsLogo from '../../assets/images/logos/ups.svg'
import BraintreeLogo from '../../assets/images/logos/braintree.svg'
import AuthorizeNetLogo from '../../assets/images/logos/authorize_net.svg'
import QuickbooksLogo from '../../assets/images/logos/quickbooks.svg'
import AvalaraLogo from '../../assets/images/logos/avalara.svg'
import SquareLogo from '../../assets/images/logos/square.svg'
import KlaviyoLogo from '../../assets/images/logos/klaviyo.svg'
import WalmartLogo from '../../assets/images/logos/walmart.svg'
import EbayLogo from '../../assets/images/logos/ebay.svg'
import InkfrogLogo from '../../assets/images/logos/inkfrog.svg'
import EtsyLogo from '../../assets/images/logos/etsy.svg'
import ShippoLogo from '../../assets/images/logos/shippo.svg'
import ShipStationLogo from '../../assets/images/logos/shipstation.svg'
import BrightpearlLogo from '../../assets/images/logos/brightpearl.svg'
import ZapierLogo from '../../assets/images/logos/zapier.svg'
import OmnisendLogo from '../../assets/images/logos/omnisend.svg'
import DropboxLogo from '../../assets/images/logos/dropbox.svg'
import GoogleDriveLogo from '../../assets/images/logos/google_drive.svg'
import S3Logo from '../../assets/images/logos/s3.svg'
import FtpLogo from '../../assets/images/logos/ftp.svg'
import GoogleAdsLogo from '../../assets/images/logos/google_ads.svg'
import BingAdsLogo from '../../assets/images/logos/bing_ads.svg'
import AmazonAdsLogo from '../../assets/images/logos/amazon_ads.svg'
import AdrollLogo from '../../assets/images/logos/adroll.svg'
import SnapchatLogo from '../../assets/images/logos/snapchat.svg'
import PinterestLogo from '../../assets/images/logos/pinterest.svg'
import SendgridLogo from '../../assets/images/logos/sendgrid.svg'
import HubspotLogo from '../../assets/images/logos/hubspot.svg'
import EasypostLogo from '../../assets/images/logos/easypost.svg'
import RecurlyLogo from '../../assets/images/logos/recurly.svg'
import ZendeskLogo from '../../assets/images/logos/zendesk.svg'
import IntercomLogo from '../../assets/images/logos/intercom.svg'
import CrazyeggLogo from '../../assets/images/logos/crazyegg.svg'
import OptimizelyLogo from '../../assets/images/logos/optimizely.svg'
import SlackLogo from '../../assets/images/logos/slack.svg'
import TeamsLogo from '../../assets/images/logos/teams.svg'
import PaypalLogo from '../../assets/images/logos/paypal.svg'
import WixLogo from '../../assets/images/logos/wix.svg'
import OpenAILogo from '../../assets/images/logos/openai.svg'
import OpenAIAdsLogo from './components/OpenAIAdsLogo'
import ApiStoreLogo from '../../assets/images/logos/api_store.svg'
import PayhelmLogo from '../../assets/images/payhelm-logo-blue.png'
import SmileIoLogo from '../../assets/images/logos/smile_io.svg'
import FeedonomicsLogo from '../../assets/images/logos/feedonomics.png'
import DataFeedWatchLogo from '../../assets/images/logos/datafeedwatch.png'
import GoogleMerchantCenterLogo from '../../assets/images/logos/google_merchant_center.png'
import GoogleLogo from '../../assets/images/logos/google.svg'
import GoogleSearchConsoleLogo from '../../assets/images/logos/google_search_console.svg'
import BigQueryLogo from '../../assets/images/logos/bigquery.svg'
import MakeswiftLogo from '../../assets/images/logos/makeswift.svg'
import TikTokLogo from '../../assets/images/logos/tiktok.svg'
import LinkedInLogo from '../../assets/images/logos/linkedin.svg'
import XLogo from '../../assets/images/logos/x.svg'
import RithumLogo from '../../assets/images/logos/rithum.svg'
import MetaLogo from '../../assets/images/logos/meta.svg'
import ConstantContactLogo from '../../assets/images/logos/constantcontact.svg'
import PayHelmMcpLogo from '../../assets/images/payhelm-logo-blue.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCsv } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { selectRootUser } from 'rootSlice'
import { getSecretId } from './channels/generic/helpers'
import {
  fetchAllPublicKeys,
  fetchMcpPublicKeys,
  resetIntegrationCredentials,
  selectAllPublicKeys,
  selectAllPublicKeysStatus,
  selectInkfrogListingsStatsNonce,
  selectInkfrogOrdersStatsNonce,
  selectInkfrogOrdersRecentImportsLimit,
  selectMcpPublicKeys,
  selectMcpPublicKeysStatus,
} from './integrationsSlice'
import {
  fetchAllSecrets,
  resetAwsSecrets,
  selectAllSecrets,
  selectAllSecretsStatus,
} from '../../features/aws/awsSecretsManagerSlice'
import { zipPublicAndPrivateKeys } from './utils'
import { isTeamOwner as checkIsTeamOwner } from './isTeamOwner'
import { inkfrogListingsStatsUrl, inkfrogOrdersStatsUrl } from 'urls'
import { getAxiosDefaultConfig } from '../../modules/utils'
import { parseIntegrationTags, isShippoIntegrationKeyId } from './integrationTags'
import { collectGmcRows } from './channels/googleMerchantCenter/gmcAccountSetup'

/**
 * Same shape as integration list rows — only for matching the Integrations search bar.
 * Keeps PayHelm API Key / MCP Custom Tools cards in sync with `searchFilterPredicate`.
 */
/** Keys like `userId--meta--accountId` are the same product as facebook_ads. */
function integrationIdMatchesHint(registryId: string, hint: string): boolean {
  const a = String(registryId || '').replace(/-/g, '_')
  const b = String(hint || '').replace(/-/g, '_')
  if (!a || !b) return false
  if (a === b) return true
  return (a === 'facebook_ads' && b === 'meta') || (a === 'meta' && b === 'facebook_ads')
}

function keyIdMatchesIntegration(keyId: string, integrationId: string): boolean {
  if (!keyId || !integrationId) return false
  // X and X Ads share a name prefix, so substring matching would show every
  // `--xcom-ads--` secret on the organic X card as well.
  if (integrationId === 'xcom' || integrationId === 'xcom_ads') {
    return integrationKeyMatches(integrationId, keyId)
  }
  if (keyId.includes(integrationId)) return true
  const altDash = integrationId.replace(/_/g, '-')
  const altUnderscore = integrationId.replace(/-/g, '_')
  if (keyId.includes(altDash) || keyId.includes(altUnderscore)) return true
  return integrationIdMatchesHint(integrationId, String(keyId).split('--')[1] || '')
}

export const payhelmApiKeyCardSearchRecord: Record<string, string> = {
  id: 'payhelm_api_key',
  channel: 'PayHelm',
  title: 'Payhelm API Key',
  description:
    'Create an API key to gain access to our API. Generating a new key will replace your current key. REST API access.',
}

export const payhelmMcpCustomToolsCardSearchRecord: Record<string, string> = {
  id: 'payhelm_mcp_custom_tools',
  channel: 'PayHelm MCP',
  title: 'PayHelm MCP Custom Tools',
  description:
    'Register HTTPS endpoints as tools your AI agent can call in Agent mode. Import from JSON Schema or add endpoints manually.',
}

export const alexaSkillCardSearchRecord: Record<string, string> = {
  channel: 'Amazon Alexa',
  title: 'Amazon Alexa',
  description:
    'Ask Alexa questions about your store. Query sales, orders, and customers by voice — powered by the PayHelm AI agent.',
}

export function useIntegrations({ accounts, ownerId, sharedAccountIds, currentUserId, inOrgContext = false }) {
  const dispatch = useDispatch()
  const user = useSelector(selectRootUser)
  const isTeamOwner = checkIsTeamOwner(user)
  const logoClassName = 'tw-max-w-full tw-max-h-full'

  const integrationsData = [
    {
      id: 'bigcommerce',
      channel: 'Bigcommerce',
      title: 'BigCommerce',
      description:
        'PayHelm for BigCommerce creates customer insights, sales analysis, & product performance data for informed decisions and improved ROI.',
      logo: <img src={BigcommerceLogo} className={logoClassName} alt="Bigcommerce logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'shopify',
      channel: 'Shopify',
      title: 'Shopify',
      description:
        'Integrate Shopify with PayHelm to deliver real-time customer insights, sales analysis, and store performance data for better business decisions and ROI.',
      logo: <img src={ShopifyLogo} className={logoClassName} alt="Shopify logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'woocommerce',
      channel: 'Woocommerce',
      title: 'WooCommerce',
      description:
        'Connect a WordPress site with WooCommerce for real-time customer insights, sales analysis, and SKU performance data.',
      logo: <img src={WoocommerceLogo} className={logoClassName} alt="WooCommerce logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: true,
    },
    {
      id: 'wordpress',
      channel: 'WordPress',
      title: 'WordPress',
      description:
        'Link a WordPress site without WooCommerce for PayHelm AI site tools — pages, posts, media, theme/CSS, pixel, and settings. No store data import.',
      logo: <img src={WordpressLogo} className={logoClassName} alt="WordPress logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: true,
    },
    {
      id: 'shipsurance',
      channel: 'Shipsurance',
      title: 'Shipsurance',
      description:
        "Purchase Shipping Insurance through ShipSurance. Connect your data with PayHelm's robust analytics platform. Unlock your data and grow your business.",
      logo: <img src={ShipsuranceLogo} className={logoClassName} alt="Shipsurance logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'google_analytics',
      channel: 'Google Analytics',
      title: 'Google Analytics',
      description:
        'Analyze your Google Analytics traffic from inside of PayHelm.  Perform conversion audits and ensure your tracking your success.',
      logo: <img src={GoogleAnalyticsLogo} className={logoClassName} alt="Google Analytics logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'google_marketing',
      channel: 'Google Marketing',
      title: 'Google Marketing',
      description:
        'Connect Google Analytics, Tag Manager, Merchant Center, and Search Console in one non-Cloud OAuth consent. BigQuery is connected separately so its Workspace session policy cannot take these integrations down.',
      logo: <img src={GoogleLogo} className={logoClassName} alt="Google Marketing logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'google_tag_manager',
      channel: 'Google Tag Manager',
      title: 'Google Tag Manager',
      description:
        'Connect Google Tag Manager with a dedicated OAuth client so PayHelm and MCP can list containers, workspaces, and versions, and publish when you approve.',
      logo: <img src={GoogleTagManagerLogo} className={logoClassName} alt="Google Tag Manager logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'google_search_console',
      channel: 'Google Search Console',
      title: 'Google Search Console',
      description:
        'Connect Search Console with Google OAuth so PayHelm and the AI agent can query search analytics, inspect URLs, and manage sitemaps.',
      logo: <img src={GoogleSearchConsoleLogo} className={logoClassName} alt="Google Search Console logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'bigquery',
      channel: 'Google BigQuery',
      title: 'Google BigQuery',
      description:
        'Connect Google BigQuery with Google OAuth or a GCP service-account JSON key. Service accounts mint JWT bearer tokens and are not subject to Workspace Cloud session reauth. Choose which projects the AI can use in Settings → My AI.',
      logo: <img src={BigQueryLogo} className={logoClassName} alt="Google BigQuery logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: true,
    },
    {
      id: 'Paypal Merchant',
      channel: 'Paypal Merchant',
      title: 'Paypal',
      description:
        'Analyze your PayPal fees and PayPal sales for your store or any source of revenue.  Get flexible reporting and take your data with you.',
      logo: <img src={PaypalLogo} className={logoClassName} alt="Paypal logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'shipstation',
      channel: 'Shipstation',
      title: 'ShipStation',
      description:
        'Analyze your shipping label cost and insurance fees.  Know your average shipping profit and ensure you are not losing money on shipping.',
      logo: <img src={ShipStationLogo} className={logoClassName} alt="ShipStation logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'shippo',
      channel: 'Shippo',
      title: 'Shippo',
      description:
        'Connect Shippo to analyze label costs, insurance, returns, and shipping spend with line-item detail. Create shipments, purchase labels, and track packages via AI.',
      logo: <img src={ShippoLogo} className={logoClassName} alt="Shippo logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'slack',
      channel: 'Slack',
      title: 'Slack',
      description:
        'Receive order notifications in Slack and chat with the PayHelm AI agent via @mention or DM.',
      logo: <img src={SlackLogo} className={logoClassName} alt="Slack logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: true,
    },
    {
      id: 'teams',
      channel: 'Microsoft Teams',
      title: 'Microsoft Teams',
      description:
        'Chat with the PayHelm AI agent in Microsoft Teams via @mention or DM. Build reports, analyze performance, and run Task Library workflows.',
      logo: <img src={TeamsLogo} className={logoClassName} alt="Microsoft Teams logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: true,
    },
    {
      id: 'amazon',
      channel: 'Amazon',
      title: 'Amazon',
      description:
        'Analyze your Amazon orders and compare your sales across channels.  Easily know your best products and grow your sales.',
      logo: <img src={AmazonLogo} className={logoClassName} alt="Amazon logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'magento',
      channel: 'Magento',
      title: 'Magento',
      description:
        'Magento for PayHelm boosts decision-making with real-time insights on customer behavior, sales, site performance for improved ROI.',
      logo: <img src={MagentoLogo} className={logoClassName} alt="Magento logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'stripe',
      channel: 'Stripe',
      title: 'Stripe',
      description:
        'Analyze your Stripe fees and keep your Stripe data aligned across all your sources of data.  Report on your monthly or quarterly sales.',
      logo: <img src={StripeLogo} className={logoClassName} alt="Stripe logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: true,
      pkeyTableEnabled: true,
    },
    {
      id: 'mailchimp',
      channel: 'Mailchimp',
      title: 'Mailchimp',
      description:
        'Import & sync your customers to Mailchimp.  Enrich your Mailchimp contact profiles using meta data from your sources of data.',
      logo: <img src={MailchimpLogo} className={logoClassName} alt="Mailchimp logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'constant_contact',
      channel: 'Constant Contact',
      title: 'Constant Contact',
      description:
        'Import & sync your customers to Constant Contact.  Enrich your Constant Contact contact profiles using meta data from your sources of data.',
      logo: <img src={ConstantContactLogo} className={logoClassName} alt="Constant Contact logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'salesforce',
      channel: 'Salesforce',
      title: 'Salesforce',
      description:
        'Import & sync your customers with SFDC.  Select which meta data should be sent to SFDC and bring your CRM to your PayHelm reports.',
      logo: <img src={SalesforceLogo} className={logoClassName} alt="Salesforce logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'fedEx',
      channel: 'FedEx',
      title: 'FedEx',
      description: 'Enrich your PayHelm reports using your FedEx data.  Ship using PayHelm with your FedEx profile.',
      logo: <img src={FedExLogo} className={logoClassName} alt="FedEx logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'usps',
      channel: 'USPS',
      title: 'USPS',
      description: 'Enrich your PayHelm reports using your USPS data.  Ship using PayHelm with your USPS profile.',
      logo: <img src={UspsLogo} className={logoClassName} alt="USPS logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'ups',
      channel: 'UPS',
      title: 'UPS',
      description: 'Enrich your PayHelm reports using your UPS data.  Ship using PayHelm with your UPS profile.',
      logo: <img src={UpsLogo} className={logoClassName} alt="UPS logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'facebook_ads',
      channel: 'Facebook Ads',
      title: 'Meta',
      description: 'Analyze your social paid advertising performance.  Know the ROAS for your Meta (Facebook & Instagram) campaigns.',
      logo: <img src={MetaLogo} className={logoClassName} alt="Meta logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'braintree',
      channel: 'Braintree',
      title: 'Braintree',
      description:
        'Analyze your Braintree fees and Braintree sales for your store or any source of revenue.  Enrich your transactions with Braintree data.',
      logo: <img src={BraintreeLogo} className={logoClassName} alt="Braintree logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'authorize_net',
      channel: 'Authorize.Net',
      title: 'Authorize.Net',
      description:
        'Analyze your Authorize.net fees and Authorize.net sales for your store or any source of revenue.  Enrich your transactions with Authorize.net data.',
      logo: <img src={AuthorizeNetLogo} className={logoClassName} alt="Authorize.net logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'quickbooks',
      channel: 'Quickbooks',
      title: 'Quickbooks',
      description:
        'Import your information into Quickbooks.  Analyze more details than ever inside Quickbooks or pull meta data into PayHelm.',
      logo: <img src={QuickbooksLogo} className={logoClassName} alt="Quickbooks logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'avalara',
      channel: 'Avalara',
      title: 'Avalara',
      description:
        'Import your information into Avalara.  Analyze more details than ever inside Avalara or pull meta data into PayHelm.',
      logo: <img src={AvalaraLogo} className={logoClassName} alt="Mailchimp logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'square',
      channel: 'Square',
      title: 'Square',
      description:
        'Analyze your Square fees and POS performance for your store or any source of revenue.  Enrich your transactions with Square data.',
      logo: <img src={SquareLogo} className={logoClassName} alt="Square logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'klaviyo',
      channel: 'Klaviyo',
      title: 'Klaviyo',
      description:
        'Connect your store data with your Klaviyo email campaigns.  Know which customer segment is opening your emails & analyze meta data.',
      logo: <img src={KlaviyoLogo} className={logoClassName} alt="Klaviyo logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'walmart',
      channel: 'Walmart',
      title: 'Walmart',
      description:
        'Analyze your Walmart performance across all your channels.  Analyze product & customer performance.  Enrich your PayHelm reports using Walmart meta data.',
      logo: <img src={WalmartLogo} className={logoClassName} alt="Walmart logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: true,
      unlinkRequirements: 'ID',
      unlinkExample: 'walmart_123456789',
      unlinkIdCol: 'selling_partner_id',
    },
    {
      id: 'ebay',
      channel: 'eBay',
      title: 'eBay',
      description:
        'Analyze your eBay performance across all your channels.  Analyze product & customer performance.  Enrich your PayHelm reports using eBay meta data.',
      logo: <img src={EbayLogo} className={logoClassName} alt="Ebay logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'inkfrog_listings',
      channel: 'inkfrog_listings',
      title: 'Inkfrog (CSV — listings & orders)',
      description:
        'As Inkfrog winds down, upload listings or orders CSV exports from Inkfrog. Listings are stored for reference; orders are deduped by marketplace order id and can be synced to search after import.',
      logo: <img src={InkfrogLogo} className={logoClassName} alt="Inkfrog" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'etsy',
      channel: 'Etsy',
      title: 'Etsy',
      description:
        'Analyze your Etsy performance across all your channels.  Analyze product & customer performance.  Enrich your PayHelm reports using Etsy meta data.',
      logo: <img src={EtsyLogo} className={logoClassName} alt="Etsy logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'brightpearl',
      channel: 'Brightpearl',
      title: 'Brightpearl',
      description:
        'Bring your Brightpearl data into PayHelm.  Analyze your performance and enrich your PayHelm data with Brightpearl data points.',
      logo: <img src={BrightpearlLogo} className={logoClassName} alt="Brightpearl logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'zapier',
      channel: 'Zapier',
      title: 'Zapier',
      description:
        'Connect into the strong data network of Zapier.  Bring your PayHelm information with you and connect to many other sources.',
      logo: <img src={ZapierLogo} className={logoClassName} alt="Zapier logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'omnisend',
      channel: 'Omnisend',
      title: 'Omnisend',
      description:
        'Connect your store data with your Omnisend email campaigns.  Know which customer segment is opening your emails & analyze meta data.',
      logo: <img src={OmnisendLogo} className={logoClassName} alt="Omnisend logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'dropbox',
      channel: 'Dropbox',
      title: 'Dropbox',
      description:
        'Export your email to DropBox.  Get daily, weekly, monthly or quarterly reports automatically sent to your Dropbox account.',
      logo: <img src={DropboxLogo} className={logoClassName} alt="Dropbox logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'google_drive',
      channel: 'Google Drive',
      title: 'Google Drive',
      description:
        'Export your email to Google Drive.  Get daily, weekly, monthly or quarterly reports automatically sent to your Google Drive storage.',
      logo: <img src={GoogleDriveLogo} className={logoClassName} alt="Google Drive logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 's3',
      channel: 'S3',
      title: 'S3',
      description:
        'Export your email to S3.  Integrate your data from S3 to your AWS jobs or services right from S3.  Get daily, weekly, monthly, or quarterly exports.',
      logo: <img src={S3Logo} className={logoClassName} alt="AWS S3 logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'ftp',
      channel: 'FTP',
      title: 'FTP',
      description:
        'Export your email to SFPT.  Get daily, weekly, monthly or quarterly reports automatically sent to your SFPT directory.',
      logo: <img src={FtpLogo} className={logoClassName} alt="FTP logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'upload',
      channel: 'upload',
      title: 'CSV Order Upload',
      description:
        'Upload your orders via CSV and correct or adjust fields—product costs, gateway fees, shipping, tracking, and metadata—so your PayHelm reports reflect the right data.',
      logo: <FontAwesomeIcon icon={faFileCsv} color={'#1D6F42'} size="3x" className={logoClassName} />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'google_ads',
      channel: 'Google Ads',
      title: 'Google Ads',
      description: 'Analyze your search paid advertising performance.  Know the ROAS for your Google Ads campaigns.',
      logo: <img src={GoogleAdsLogo} className={logoClassName} alt="Google Ads logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'bing_ads',
      channel: 'Bing Ads',
      title: 'Bing Ads',
      description: 'Analyze your search paid advertising performance.  Know the ROAS for your Bing Ads campaigns.',
      logo: <img src={BingAdsLogo} className={logoClassName} alt="Bing Ads logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'amazon-ads',
      channel: 'Amazon Ads',
      title: 'Amazon Ads',
      description:
        'Analyze your search paid advertising performance on Amazon. Know the ROAS for your Amazon Ads campaigns and which products perform. You can connect multiple Amazon Ads logins.',
      logo: <img src={AmazonAdsLogo} className={logoClassName} alt="Amazon Ads logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'adroll',
      channel: 'Adroll',
      title: 'Adroll',
      description:
        'Analyze your Adroll network paid advertising performance.  Know the ROAS for your paid ad campaigns.',
      logo: <img src={AdrollLogo} className={logoClassName} alt="Adroll logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'snapchat',
      channel: 'Snapchat',
      title: 'Snapchat',
      description: 'Analyze your social paid advertising performance.  Know the ROAS for your Snapchat campaigns.',
      logo: <img src={SnapchatLogo} className={logoClassName} alt="Snapchat logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'pinterest',
      channel: 'Pinterest',
      title: 'Pinterest',
      description:
        'Analyze your Pinterest performance across all your channels.  Analyze product & PIN performance.  Enrich your PayHelm reports using Pinterest meta data.',
      logo: <img src={PinterestLogo} className={logoClassName} alt="Pinterest logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'tiktok',
      channel: 'TikTok',
      title: 'TikTok',
      description:
        'Analyze your TikTok performance across all your channels.  Analyze product & video performance.  Enrich your PayHelm reports using TikTok meta data.',
      logo: <img src={TikTokLogo} className={logoClassName} alt="TikTok logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'linkedin',
      channel: 'LinkedIn',
      title: 'LinkedIn',
      description:
        'Analyze your LinkedIn Ads performance across all your channels.  Analyze campaign & creative performance.  Enrich your PayHelm reports using LinkedIn meta data.',
      logo: <img src={LinkedInLogo} className={logoClassName} alt="LinkedIn logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'xcom',
      channel: 'X',
      title: 'X (Twitter)',
      description:
        'Connect your X (Twitter) account so PayHelm AI can post, moderate replies, and track organic analytics.',
      logo: <img src={XLogo} className={logoClassName} alt="X logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'xcom_ads',
      channel: 'X Ads',
      title: 'X Ads',
      description:
        'Connect your X advertiser identity to analyze performance and create or manage X Ads campaigns.',
      logo: <img src={XLogo} className={logoClassName} alt="X Ads logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'openai_ads',
      channel: 'OpenAI Ads',
      title: 'OpenAI Ads',
      description:
        'Manage ChatGPT Ads campaigns, creatives, custom audiences, and insights from PayHelm AI. Connect your Ads Manager API key.',
      logo: <OpenAIAdsLogo />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      pkeyTableEnabled: true,
    },
    {
      id: 'channeladvisor',
      channel: 'ChannelAdvisor',
      title: 'Rithum (ChannelAdvisor)',
      description:
        'Connect Rithum ChannelAdvisor to automatically pull product costs and inventory metrics when BigCommerce, eBay, or Amazon orders are imported.',
      logo: <img src={RithumLogo} className={logoClassName} alt="Rithum logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: true,
      unlinkRequirements: 'Account ID',
      unlinkExample: 'mock_account_123',
      unlinkIdCol: 'account_id',
    },
    {
      id: 'sendgrid',
      channel: 'Sendgrid',
      title: 'Sendgrid',
      description:
        'Connect your store data with your Sendgrid email campaigns.  Import your customers to Sendgrid and keep track of their performance.',
      logo: <img src={SendgridLogo} className={logoClassName} alt="Sendgrid logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'hubspot',
      channel: 'Hubspot',
      title: 'Hubspot',
      description:
        'Connect your CRM with your detailed PayHelm business data.  Ensure your customer information is kept up-to-date and accurate.',
      logo: <img src={HubspotLogo} className={logoClassName} alt="Hubspot logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'easypost',
      channel: 'Easypost',
      title: 'Easypost',
      description:
        'Enrich your PayHelm reports using your Easypost data.  Ship using PayHelm with your Easypost profile.',
      logo: <img src={EasypostLogo} className={logoClassName} alt="Easypost logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'recurly',
      channel: 'Recurly',
      title: 'Recurly',
      description:
        'Connect your Recurly transaction data with your store business data in PayHelm.  Get enriched reports using Recurly meta data in PayHelm.',
      logo: <img src={RecurlyLogo} className={logoClassName} alt="Recurly logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'zendesk',
      channel: 'Zendesk',
      title: 'Zendesk',
      description:
        'Connect your Zendesk helpdesk with your store business data.  Keep track of which customers are engaged and how they interact with your business.',
      logo: <img src={ZendeskLogo} className={logoClassName} alt="Zendesk logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'intercom',
      channel: 'Intercom',
      title: 'Intercom',
      description:
        'Connect your Intercom customer list with your store business information.  Add meta data to your customer profiles and ensure they get detailed messaging.',
      logo: <img src={IntercomLogo} className={logoClassName} alt="Intercom logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'crazyegg',
      channel: 'Crazyegg',
      title: 'Crazyegg',
      description:
        'Analyze your Crazyegg performance across all your channels.  Analyze product & customer performance.  Enrich your PayHelm reports using Crazyegg meta data.',
      logo: <img src={CrazyeggLogo} className={logoClassName} alt="Crazyegg logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'optimizely',
      channel: 'Optimizely',
      title: 'Optimizely',
      description:
        'Engage your customers with accurately store data with Optimizely & PayHelm.  Analyze meta data and make accurate decisions around performance.',
      logo: <img src={OptimizelyLogo} className={logoClassName} alt="Optimizely logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'wix',
      channel: 'Wix',
      title: 'Wix',
      description:
        'Integrate Wix with PayHelm to deliver real-time customer insights, sales analysis, and store performance data for better business decisions and ROI.',
      logo: <img src={WixLogo} className={logoClassName} alt="Wix logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: true,
      uninstallEnabled: false,
    },
    {
      id: 'openai',
      channel: 'OpenAI',
      title: 'OpenAI',
      description: 'Enable OpenAI assistant to ask questions and get answers from your data.',
      logo: <img src={OpenAILogo} className={logoClassName} alt="OpenAI logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
      ownerEnabledOnly: true,
    },
    {
      id: 'api_store',
      channel: 'API Store',
      title: 'API Store',
      description:
        'Sync your ecommerce platform with our platform for customer insights, sales analysis, & product performance data for informed decisions and improved ROI.',
      logo: <img src={ApiStoreLogo} className={logoClassName} alt="ApiStore logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'payhelm_pixel',
      channel: 'PayHelm Pixel',
      title: 'PayHelm Pixel',
      description:
        'Forward your pixels to our management system.',
      logo: <img src={PayhelmLogo} className={logoClassName} alt="PayHelm logo" />,
      enabled: true,
      settingsEnabled: true,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'smile.io',
      channel: 'Smile.io',
      title: 'Smile.io',
      description: 'Analyze your Smile.io performance across all your channels. Analyze product & customer performance.',
      logo: <img src={SmileIoLogo} className={logoClassName} alt="Smile.io logo" />,
      enabled: false,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'feedonomics',
      channel: 'Feedonomics',
      title: 'Feedonomics',
      description:
        'For BigCommerce catalogs synced through Feedonomics, enrich product feeds with PayHelm data and analytics. Build custom rules to filter listings by product, customer, and traffic performance across the channels Feedonomics powers.',
      logo: <img src={FeedonomicsLogo} className={logoClassName} alt="Feedonomics logo" />,
      enabled: true,
      settingsEnabled: true,
      backfillEnabled: false,
      type: 'feed',
      uninstallEnabled: false,
    },
    {
      id: 'datafeedwatch',
      channel: 'DataFeedWatch',
      title: 'DataFeedWatch',
      description:
      'Enrich your DataFeedWatch feed using PayHelm\'s rich data & analytics.  Make custom rules to automatically filter your feed based on product, customer, and traffic performance.',
      logo: <img src={DataFeedWatchLogo} className={logoClassName} alt="DataFeedWatch logo" />,
      enabled: false,
      settingsEnabled: true,
      backfillEnabled: false,
      connectDisabled: true,
      type: 'feed',
      uninstallEnabled: false,
    },
    {
      id: 'google_merchant_center',
      channel: 'Google Merchant Center',
      title: 'Google Merchant Center',
      description:
        'Connect Merchant Center with Google OAuth so PayHelm and the AI agent can audit product disapprovals, feed health, promotions, inventory, and account issues.',
      logo: <img src={GoogleMerchantCenterLogo} className={logoClassName} alt="Google Merchant Center logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      connectDisabled: false,
      type: 'feed',
      uninstallEnabled: false,
    },
    {
      id: 'makeswift',
      channel: 'Makeswift',
      title: 'Makeswift',
      description:
        'Connect Makeswift to PayHelm with a secure API key. Pairs with BigCommerce headless storefronts (including Catalyst with Makeswift) for visual page building while credentials stay in an encrypted store.',
      logo: <img src={MakeswiftLogo} className={logoClassName} alt="Makeswift logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    },
    {
      id: 'payhelm_ai_mcp',
      channel: 'PayHelm MCP AI',
      title: 'PayHelm MCP AI',
      description: inOrgContext
        ? 'Generate this organization’s MCP key to use Agent Mode and Slack AI in org-bound channels. Required for org Slack — a personal key will not work there.'
        : 'Connect your PayHelm MCP key to use Agent Mode in AI chat and Slack. Generate a key here before chatting with PayHelm in Slack.',
      logo: <img src={PayHelmMcpLogo} className={logoClassName} alt="PayHelm MCP logo" />,
      enabled: true,
      settingsEnabled: false,
      backfillEnabled: false,
      uninstallEnabled: false,
    }
  ]

  /**
   *
   * Add keys & connected status to integrations data
   *
   */
  const allPublicKeys = useSelector(selectAllPublicKeys)
  const allPublicKeysStatus = useSelector(selectAllPublicKeysStatus)
  const mcpPublicKeys = useSelector(selectMcpPublicKeys)
  const mcpPublicKeysStatus = useSelector(selectMcpPublicKeysStatus)
  const allPrivateKeys = useSelector(selectAllSecrets)
  const allPrivateKeysStatus = useSelector(selectAllSecretsStatus)
  const [allKeys, setAllKeys] = useState(null)

  const prevOwnerIdRef = useRef<string | number | null>(null)
  useEffect(() => {
    if (!ownerId) return
    if (prevOwnerIdRef.current !== null && prevOwnerIdRef.current !== ownerId) {
      dispatch(resetIntegrationCredentials())
      dispatch(resetAwsSecrets())
      setAllKeys(null)
    }
    prevOwnerIdRef.current = ownerId
  }, [ownerId, dispatch])

  useEffect(() => {
    if (allPublicKeysStatus === 'idle' && ownerId) {
      dispatch(fetchAllPublicKeys({ ownerId }))
    }
  }, [allPublicKeysStatus, ownerId, dispatch])

  useEffect(() => {
    const hasUserId = currentUserId != null && String(currentUserId).trim() !== ''
    const canFetchMcp = isTeamOwner ? ownerId != null || hasUserId : hasUserId
    if (mcpPublicKeysStatus === 'idle' && canFetchMcp) {
      dispatch(
        fetchMcpPublicKeys({
          ownerId,
          sharedAccountIds: sharedAccountIds || [],
          currentUserId,
          isTeamOwner,
        })
      )
    }
  }, [mcpPublicKeysStatus, ownerId, sharedAccountIds, currentUserId, isTeamOwner, dispatch])

  useEffect(() => {
    if (allPrivateKeysStatus === 'idle' && ownerId) {
      dispatch(fetchAllSecrets({ ownerId }))
    }
  }, [allPrivateKeysStatus, ownerId, dispatch])

  useEffect(() => {
    if (!allPublicKeys || !allPrivateKeys) return
    const _allKeys = zipPublicAndPrivateKeys(allPublicKeys, allPrivateKeys)
    setAllKeys(_allKeys)
  }, [allPublicKeys, allPrivateKeys])

  // PayHelm MCP AI: use owner + shared account keys when available; else fall back to owner-only keys.
  const MCP_KEY_SUFFIX_NEW = 'payhelm_ai_mcp'
  const mcpKeysSource = Array.isArray(mcpPublicKeys) && mcpPublicKeys.length > 0
    ? mcpPublicKeys
    : Array.isArray(allPublicKeys)
      ? allPublicKeys
      : []
  const mcpTeamKeys = (() => {
    const matchesMcp = (k) =>
      k.keyId && (k.keyId.includes(MCP_KEY_SUFFIX_NEW) || k.keyId.includes('openai_connector'))
    const list = (mcpKeysSource || []).filter(matchesMcp)
    if (isTeamOwner) return list
    const uid = currentUserId != null && String(currentUserId).trim() !== '' ? String(currentUserId) : ''
    if (!uid) return []
    return list.filter((k) => k.keyId.startsWith(`${uid}--`))
  })()
  const hasMcpKey = mcpTeamKeys.length > 0

  const inkfrogListingsStatsNonce = useSelector(selectInkfrogListingsStatsNonce)
  const inkfrogOrdersStatsNonce = useSelector(selectInkfrogOrdersStatsNonce)
  const inkfrogOrdersRecentImportsLimit = useSelector(selectInkfrogOrdersRecentImportsLimit)
  const [inkfrogListingStats, setInkfrogListingStats] = useState<{
    rowCount: number
    importCount: number
    byEbayUser: Array<{ ebayUser: string | null; listingCount: number }>
  } | null>(null)

  useEffect(() => {
    let cancelled = false
    axios
      .get<{
        rowCount?: number
        importCount?: number
        byEbayUser?: Array<{ ebayUser?: string | null; listingCount?: number }>
      }>(inkfrogListingsStatsUrl, getAxiosDefaultConfig())
      .then((res) => {
        if (cancelled) return
        const raw = Array.isArray(res.data?.byEbayUser) ? res.data.byEbayUser : []
        setInkfrogListingStats({
          rowCount: Number(res.data?.rowCount ?? 0),
          importCount: Number(res.data?.importCount ?? 0),
          byEbayUser: raw.map((row) => ({
            ebayUser: row?.ebayUser ?? null,
            listingCount: Number(row?.listingCount ?? 0),
          })),
        })
      })
      .catch(() => {
        if (!cancelled) setInkfrogListingStats(null)
      })
    return () => {
      cancelled = true
    }
  }, [inkfrogListingsStatsNonce])

  const [inkfrogOrderStats, setInkfrogOrderStats] = useState<{
    orderCount: number
    importCount: number
    bySeller: Array<{ seller: string | null; orderCount: number }>
    recentImports: Array<{
      id: string
      rowCount: number
      channel: string
      originalFilename: string | null
      createdAt: string
    }>
    orderImportsRetentionNote?: string
  } | null>(null)

  useEffect(() => {
    let cancelled = false
    axios
      .get<{
        orderCount?: number
        importCount?: number
        bySeller?: Array<{ seller?: string | null; orderCount?: number }>
        recentImports?: Array<{
          id?: string
          rowCount?: number
          channel?: string
          originalFilename?: string | null
          createdAt?: string
        }>
        orderImportsRetentionNote?: string
      }>(inkfrogOrdersStatsUrl, {
        ...getAxiosDefaultConfig(),
        params: { recent_imports_limit: inkfrogOrdersRecentImportsLimit },
      })
      .then((res) => {
        if (cancelled) return
        const sl = Array.isArray(res.data?.bySeller) ? res.data.bySeller : []
        const ri = Array.isArray(res.data?.recentImports) ? res.data.recentImports : []
        setInkfrogOrderStats({
          orderCount: Number(res.data?.orderCount ?? 0),
          importCount: Number(res.data?.importCount ?? 0),
          bySeller: sl.map((row) => ({
            seller: row?.seller ?? null,
            orderCount: Number(row?.orderCount ?? 0),
          })),
          recentImports: ri.map((row) => ({
            id: String(row?.id ?? ''),
            rowCount: Number(row?.rowCount ?? 0),
            channel: String(row?.channel ?? ''),
            originalFilename: row?.originalFilename ?? null,
            createdAt: String(row?.createdAt ?? ''),
          })),
          orderImportsRetentionNote:
            typeof res.data?.orderImportsRetentionNote === 'string'
              ? res.data.orderImportsRetentionNote
              : undefined,
        })
      })
      .catch(() => {
        if (!cancelled) setInkfrogOrderStats(null)
      })
    return () => {
      cancelled = true
    }
  }, [inkfrogOrdersStatsNonce, inkfrogOrdersRecentImportsLimit])

  const resolveChannelFromKeyId = (keyId: string) => {
    if (!keyId) return null
    const integrationId = keyId.split('--')[1]
    if (!integrationId) return null
    const integration = _.find(
      integrationsData,
      ({ id }) => integrationIdMatchesHint(id, integrationId)
    )
    return integration ? integration.channel : null
  }

  const connectedChannelNames = [
    ...(accounts ? accounts.map((_account) => _account.channel) : []),
    ...(allKeys && !_.isEmpty(allKeys)
      ? _.chain(allKeys)
          // Only resolve channels from allKeys for 3-segment keys
          // ({userId}--{channel}--{accountId}), i.e. pure-AWS integrations like
          // GA/GTM that never write an integrations_keys row. Shippo uses
          // {userId}--shippo--{storeKey} (3+ segments) or legacy {userId}--shippo;
          // both are covered by the allPublicKeys spread below and must NOT be
          // included here — doing so lets a stale AWS secret keep the integration
          // showing as "connected" even after the user disconnects and the row is deleted.
          .filter(({ keyId }) => {
            const parts = String(keyId).split('--')
            return parts.length >= 3 && parts[1] !== 'shippo'
          })
          .map(({ keyId }) => resolveChannelFromKeyId(keyId))
          // Tolerate hyphen <-> underscore mismatch between the SM secret name
          // segment (e.g. `google-analytics`) and the integration registry id
          // (e.g. `google_analytics`).
          .filter(channel => channel !== null)
          .uniq()
          .value()
      : []),
    // Also derive connected channels directly from allPublicKeys so that
    // integrations storing credentials server-side (e.g. Shippo with key_value
    // = "aws:") show as connected immediately after fetchAllPublicKeys resolves,
    // without needing a separate AWS secrets re-fetch.
    ...(Array.isArray(allPublicKeys)
      ? _.chain(allPublicKeys)
          .map(({ keyId }) => resolveChannelFromKeyId(keyId))
          .filter(channel => channel !== null)
          .uniq()
          .value()
      : []),
    ...(hasMcpKey ? ['PayHelm MCP AI'] : []),
  ]

  // Build a channel -> account[] map synthesized from `allPublicKeys` tags so
  // integrations that aren't represented in the session-cached `accounts`
  // payload (e.g. GA / GTM, which were just connected via OAuth) still render
  // their account table from the canonical `integrations_keys` row metadata.
  const synthesizedAccountsByChannel = (() => {
    const byChannel: Record<string, any[]> = {}
    if (Array.isArray(allPublicKeys)) {
      allPublicKeys.forEach((row) => {
        if (!row || !row.keyId) return
        const tagsMap = parseIntegrationTags(row.tags)
        const segment = String(row.keyId).split('--')[1] || ''
        const channelHint = tagsMap.channelId || segment
        if (!channelHint) return
        const integration = _.find(
          integrationsData,
          ({ id }) => integrationIdMatchesHint(id, channelHint)
        )
        if (!integration) return
        const merchantId =
          integration.id === 'shippo'
            ? tagsMap.merchant_id ||
              tagsMap.connectionId ||
              tagsMap.account_id ||
              String(row.keyId).split('--')[2] ||
              ''
            : tagsMap.connectionId ||
              tagsMap.account_id ||
              String(row.keyId).split('--')[2] ||
              ''
        const acct = {
          channel: integration.channel,
          merchant_id: merchantId,
          account_email: tagsMap.email || tagsMap.account_email || '',
          email: tagsMap.email || tagsMap.account_email || '',
          create_time: tagsMap.createdAt || tagsMap.create_time || '',
          owner: '',
          isOwner:
            currentUserId != null &&
            String(currentUserId).trim() !== '' &&
            String(row.keyId).split('--')[0] === String(currentUserId),
          _synthesized: true,
          _keyId: row.keyId,
          ...(integration.id === 'shippo'
            ? {
                payhelm_store_channel: tagsMap.payhelm_channel || '',
                shippo_token_preview: tagsMap.shippo_token_preview || '',
                account_name: [
                  tagsMap.payhelm_channel,
                  merchantId,
                  tagsMap.shippo_token_preview ? `token ${tagsMap.shippo_token_preview}` : '',
                ]
                  .filter(Boolean)
                  .join(' · '),
              }
            : {}),
          ...(integration.id === 'feedonomics' &&
          (tagsMap.feedonomics_api_key_preview || tagsMap.username)
            ? {
                account_name: String(
                  tagsMap.feedonomics_api_key_preview || tagsMap.username || ''
                ),
              }
            : {}),
          ...(integration.id === 'google_merchant_center'
            ? {
                account_name: [
                  tagsMap.merchantCenterAccountId ? `MC ${tagsMap.merchantCenterAccountId}` : null,
                  tagsMap.email,
                ]
                  .filter(Boolean)
                  .join(' · '),
              }
            : {}),
          ...(integration.id === 'makeswift'
            ? (() => {
                const keyOwnerId = String(row.keyId).split('--')[0] || ''
                const emailFromTags =
                  tagsMap.payhelm_account_email ||
                  tagsMap.account_email ||
                  tagsMap.email ||
                  ''
                const emailFallback =
                  keyOwnerId && String(user?.id) === keyOwnerId ? String(user?.email || '').trim() : ''
                const displayEmail = String(emailFromTags || emailFallback || '').trim()
                return {
                  account_name: displayEmail,
                  account_email: displayEmail,
                  merchant_id: '',
                }
              })()
            : {}),
        }
        if (!byChannel[integration.channel]) byChannel[integration.channel] = []
        byChannel[integration.channel].push(acct)
      })
    }

    // Also synthesize from allKeys for integrations (e.g. GA, GTM) that store
    // credentials in AWS Secrets Manager but do NOT write an integrations_keys
    // row. Those entries are absent from allPublicKeys, so the loop above
    // cannot populate their account tables. allKeys is the zip of public +
    // private keys, so it contains AWS-only entries with 3-segment keyIds
    // ({userId}--{channel}--{accountId}). Parse the email from the stored
    // JSON secretValue when available.
    if (Array.isArray(allKeys)) {
      allKeys.forEach((row) => {
        if (!row || !row.keyId) return
        const parts = String(row.keyId).split('--')
        const segment = parts[1] || ''
        const merchantId = parts[2] || ''
        if (!segment || !merchantId) return
        const integration = _.find(
          integrationsData,
          ({ id }) =>
            id === segment ||
            id === segment.replace(/-/g, '_') ||
            id === segment.replace(/_/g, '-')
        )
        if (!integration) return
        // Skip if already populated from allPublicKeys to avoid duplicates.
        // Also compare by _keyId so that Shippo rows (where allPublicKeys uses
        // tagsMap.merchant_id while allKeys uses the raw
        // base64 keyId segment) are not double-counted.
        const alreadyPresent = (byChannel[integration.channel] || []).some(
          (a) =>
            String(a.merchant_id) === String(merchantId) ||
            (a._keyId && String(a._keyId) === String(row.keyId))
        )
        if (alreadyPresent) return
        let email = ''
        try {
          if (row.privateKey) {
            const parsed = JSON.parse(row.privateKey)
            email = parsed.email || parsed.account_email || ''
          }
        } catch {}
        const acct = {
          channel: integration.channel,
          merchant_id: merchantId,
          account_email: email,
          email,
          create_time: '',
          owner: '',
          isOwner:
            currentUserId != null &&
            String(currentUserId).trim() !== '' &&
            parts[0] === String(currentUserId),
          _synthesized: true,
          _keyId: row.keyId,
        }
        if (!byChannel[integration.channel]) byChannel[integration.channel] = []
        byChannel[integration.channel].push(acct)
      })
    }

    return byChannel
  })()

  const integrationsDataWithConnectedStatus = integrationsData.map((integrationData) => {
    const isPayHelmMcp = integrationData.id === 'payhelm_ai_mcp'
    const ppKeysFromAllKeys = isPayHelmMcp && hasMcpKey
      ? mcpTeamKeys.map((k) => ({
          keyId: k.keyId,
          accountId: '',
          publicKey: '',
          privateKey: k.keyValue,
          tags: k.tags,
        }))
      : (allKeys && allKeys.filter(({ keyId }) => keyIdMatchesIntegration(keyId, integrationData.id))) || []
    // Fall back to allPublicKeys for integrations (e.g. Shippo) that store
    // credentials server-side and only keep an "aws:" pointer in integrations_keys.
    // Without this, ppKeys would be empty until allPrivateKeys (AWS secrets) is
    // re-fetched, so the modal would never show the "connected" manage view.
    const rawPpKeysForIntegration = ppKeysFromAllKeys.length > 0 || (isPayHelmMcp && hasMcpKey)
      ? ppKeysFromAllKeys
      : (Array.isArray(allPublicKeys) && allPublicKeys.filter(({ keyId }) =>
          keyIdMatchesIntegration(keyId, integrationData.id)
        ).map(({ keyId, keyValue, tags }) => ({
          keyId,
          accountId: '',
          publicKey: keyValue || '',
          privateKey: '',
          tags,
        }))) || []
    const ppKeysForIntegration = rawPpKeysForIntegration
    const realAccountsForChannel = accounts
      ? accounts.filter((_account) => {
          // Woo + store-less WordPress share Woo channel aliases in session accounts;
          // split them onto separate integration cards via store_connected.
          if (integrationData.id === 'wordpress') {
            return isStoreLessAccount(_account)
          }
          if (integrationData.id === 'woocommerce') {
            return isWooCommerceChannel(_account) && !isStoreLessAccount(_account)
          }
          return _account.channel === integrationData.channel
        })
      : []
    const synthesizedForChannel = synthesizedAccountsByChannel[integrationData.channel] || []
    const realMerchantIds = new Set(
      realAccountsForChannel.map((a) => String(a.merchant_id || ''))
    )
    // For Google integrations that carry an email, also deduplicate synthesized
    // entries by email — old SM secrets with different UUIDs but the same Google
    // email would otherwise bleed through even after the real account is deduped.
    const realEmails = new Set(
      realAccountsForChannel
        .map((a) => String(a.email || '').toLowerCase())
        .filter(Boolean)
    )
    const dedupedSynthesized = synthesizedForChannel.filter((s) => {
      // Shippo rows share merchant_id with real store accounts but must still appear.
      if (s._keyId && isShippoIntegrationKeyId(String(s._keyId))) return true
      if (!s.merchant_id && s._keyId) return true
      if (realMerchantIds.has(String(s.merchant_id || ''))) return false
      // Drop synthesized entries whose Google email is already covered by a real account.
      const sEmail = String(s.email || '').toLowerCase()
      if (sEmail && realEmails.has(sEmail)) return false
      return true
    })
    const mergedAccounts = [...realAccountsForChannel, ...dedupedSynthesized]
    const inkfrogHasRows = (inkfrogListingStats?.rowCount ?? 0) > 0
    const inkfrogHasOrders = (inkfrogOrderStats?.orderCount ?? 0) > 0
    const isGmcConnected =
      integrationData.id === 'google_merchant_center' &&
      (connectedChannelNames.includes(integrationData.channel) || mergedAccounts.length > 0)
    const gmcSetupIncomplete =
      isGmcConnected &&
      collectGmcRows({ ppKeys: ppKeysForIntegration }, allPublicKeys).some(
        (row) => row.connectionId && !row.merchantCenterAccountId
      )
    return {
      ...integrationData,
      ppKeys: ppKeysForIntegration,
      connected:
        integrationData.id === 'inkfrog_listings'
          ? inkfrogHasRows || inkfrogHasOrders
          : integrationData.id === 'wordpress' || integrationData.id === 'woocommerce'
            // Session accounts all use channel "Woocommerce"; card membership is
            // store_connected-based, so only count filtered mergedAccounts.
            ? mergedAccounts.length > 0
            : connectedChannelNames.includes(integrationData.channel) || mergedAccounts.length > 0,
      accounts: mergedAccounts,
      ...(isPayHelmMcp ? { pkeyTableEnabled: true } : {}),
      ...(integrationData.id === 'inkfrog_listings'
        ? {
            inkfrogListingRowCount: inkfrogListingStats?.rowCount ?? null,
            inkfrogListingImportCount: inkfrogListingStats?.importCount ?? null,
            inkfrogListingByEbayUser: inkfrogListingStats?.byEbayUser ?? null,
            inkfrogOrderRowCount: inkfrogOrderStats?.orderCount ?? null,
            inkfrogOrderImportCount: inkfrogOrderStats?.importCount ?? null,
            inkfrogOrderBySeller: inkfrogOrderStats?.bySeller ?? null,
            inkfrogOrderRecentImports: inkfrogOrderStats?.recentImports ?? null,
            inkfrogOrdersRecentImportsLimit: inkfrogOrdersRecentImportsLimit,
            inkfrogOrderImportsRetentionNote: inkfrogOrderStats?.orderImportsRetentionNote ?? '',
          }
        : {}),
      ...(integrationData.id === 'google_merchant_center' ? { gmcSetupIncomplete } : {}),
    }
  })
  const integrationIds = integrationsDataWithConnectedStatus.map((_integration) => _integration.id)
  const integrationEntities = integrationsDataWithConnectedStatus.reduce(
    (prev, _integration) => ({ ...prev, [_integration.id]: _integration }),
    {}
  )

  const integrations = {
    ids: integrationIds,
    entities: integrationEntities,
  }

  return { data: integrations }
}

export function useCategories({ integrationIds }) {
  const categoriesData = [
    {
      id: 'all',
      title: 'All',
      integrationIds,
    },
    {
      id: 'most_popular',
      title: 'Most Popular',
      integrationIds: ['bigcommerce', 'shopify', 'woocommerce', 'wordpress', 'google_analytics', 'google_tag_manager', 'Paypal Merchant', 'shipstation', 'etsy', 'wix', 'channeladvisor'],
    },
    {
      id: 'accounting',
      title: 'Accounting',
      integrationIds: ['avalara', 'quickbooks'],
    },
    {
      id: 'advertising',
      title: 'Advertising',
      integrationIds: ['facebook_ads', 'google_ads', 'bing_ads', 'amazon-ads', 'adroll', 'snapchat', 'pinterest', 'tiktok', 'linkedin', 'xcom_ads', 'openai_ads'],
    },
    {
      id: 'analytics',
      title: 'Analytics',
      integrationIds: ['google_analytics', 'google_tag_manager', 'google_marketing', 'google_search_console', 'google_merchant_center', 'bigquery', 'facebook_ads', 'crazyegg', 'smile.io', 'optimizely'],
    },
    {
      id: 'crm',
      title: 'CRM',
      integrationIds: ['salesforce'],
    },
    {
      id: 'customer_support',
      title: 'Customer Support',
      integrationIds: ['zendesk', 'intercom'],
    },
    {
      id: 'ecommerce',
      title: 'E-Commerce',
      integrationIds: [
        'shopify',
        'woocommerce',
        'wordpress',
        'amazon',
        'bigcommerce',
        'magento',
        'wix',
        'facebook_ads',
        'walmart',
        'etsy',
        'ebay',
        'inkfrog_listings',
        'channeladvisor',
        'api_store',
        'feedonomics',
        'google_merchant_center',
        'makeswift',
      ],
    },
    {
      id: 'fulfillment',
      title: 'Fulfillment',
      integrationIds: ['shipstation', 'shippo', 'easypost', 'shipsurance', 'fedEx', 'usps', 'ups'],
    },
    {
      id: 'inventory',
      title: 'Inventory Management',
      integrationIds: ['brightpearl', 'channeladvisor'],
    },
    {
      id: 'marketing',
      title: 'Marketing',
      integrationIds: ['magento', 'mailchimp', 'omnisend', 'klaviyo', 'sendgrid', 'hubspot', 'optimizely', 'constant_contact', 'payhelm_pixel'],
    },
    {
      id: 'payments',
      title: 'Payments',
      integrationIds: ['stripe', 'Paypal Merchant', 'amazon', 'authorize_net', 'square', 'braintree', 'recurly'],
    },
    {
      id: 'software',
      title: 'Software',
      integrationIds: ['zapier', 'openai', 'api_store'],
    },
    {
      id: 'storage',
      title: 'Storage',
      integrationIds: ['dropbox', 's3', 'google_drive', 'ftp'],
    },
    {
      id: 'tax',
      title: 'Tax',
      integrationIds: ['avalara'],
    },
  ]

  const categoryIds = categoriesData.map((_category) => _category.id)
  const categoryEntities = categoriesData.reduce((prev, _category) => ({ ...prev, [_category.id]: _category }), {})

  const categories = {
    ids: categoryIds,
    entities: categoryEntities,
  }

  return { data: categories }
}
